import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Onboarding } from 'src/app/models/onboarding';
const { API_URL } = environment;

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {

  constructor(
    private http: HttpClient,
  ) {
  }

  async create(onboarding: Onboarding): Promise<Onboarding> {
    return this.http.post<Onboarding>(`${API_URL}/onboarding`, onboarding).toPromise();
  }

}
